const isSafePath = (path) => {
  const url = new URL(path, "http://fake.tld");
  return !url.protocol.startsWith("javascript");
};
const assertSafePath = (path) => {
  if (!isSafePath(path)) {
    throw new Error(`Unsafe path used: '${path}'`);
  }
};
export {
  assertSafePath,
  isSafePath
};
//# sourceMappingURL=is-safe-path.js.map
